import Link from '../../views/PlaceOrderMsg';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { actions as statusactions } from '../../../state/status';
import { actions as authactions } from '../../../state/auth';
import { actions as assessmentactions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reponame: state.shift.assessment.reponame,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  po_num: state.shift.assessment.po_num
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      dispatch(authactions.logout())
      .then(dispatch(()=>{
        localStorage.clear();
        sessionStorage.clear();
        assessmentactions.resetAssessmentStore();
        statusactions.resetStatus();
        window.location.reload();
      }));
    },



    placeorder: ( reference_id,quotation_id) => {
      // dispatch(actions.placeorder( JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reference_id'],
      //   JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id']));

      dispatch(actions.placeorder(reference_id, 
        JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id']),
        JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['auth'])['username']);
    }
    
  };
};

const PlaceOrderMsg = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default PlaceOrderMsg;



// WEBPACK FOOTER //
// ./src/components/container/PlaceOrderMsg/index.js